import { useState } from 'react';
import { responsivePropType } from "react-bootstrap/esm/createUtilityClasses";
//API
import { StatusMenu } from "../../api/StatusMenu";
import { ClientsFetchAPI } from "../../api/Clients";
import { AuthFetchAPI } from "../../api/Auth";
import { DeliveryFeeRulesFetchAPI } from "../../api/DeliveryFeeRules";
import { PickAndGoRulesFetchAPI } from "../../api/PickAndGoRules";

async function initData() {


  let machine = "";
  // Read independently of the branchoffice/machine check below - these calls only need a
  // business id (delivery fee rules and pick&go rules are business-scoped, branchoffice_id is
  // optional), so gating `business` behind having a branchoffice/machine too meant it stayed ""
  // (and business.id undefined) during the normal "business picked, branch not chosen yet" window
  // - which is exactly when a fresh visitor lands here. That undefined business_id was going out
  // in delivery-fees-rules/pick-and-go-rules requests, 404ing, and the global 401/404 interceptor
  // was treating that as a dead session and bouncing the user around.
  let business = (localStorage.getItem("business") != "" && localStorage.getItem("business") != undefined)
    ? JSON.parse(localStorage.getItem("business"))
    : "";
  let branchoffice = "";
  let logo = ""
  let params = false
  // Real public token from generatePublicToken's response body, used explicitly via
  // x-access-token below instead of relying only on the cookie it also sets - that cookie is
  // cross-origin (frontend and API are different hosts) and browsers increasingly refuse to store/
  // send third-party cookies (always the case in Incognito/InPrivate), which otherwise leaves every
  // one of these calls with no credentials at all.
  let token = undefined
  if (localStorage.getItem('logo') != null || localStorage.getItem('logo') != undefined || localStorage.getItem('logo') != "") {
    logo = localStorage.getItem('logo')
  }
  if (localStorage.getItem("branchoffice") == "" || localStorage.getItem("branchoffice") == undefined || localStorage.getItem("machine") == "" || localStorage.getItem("machine") == undefined) {

  } else {
    params = true
    branchoffice = JSON.parse(localStorage.getItem('branchoffice'))
    machine = JSON.parse(localStorage.getItem('machine'));
  }
  let data = {}
  let deliveryFeeRule = {}

  const ensurePublicToken = async () => {
    if (!business?.id) return undefined;

    try {
      const response = await AuthFetchAPI.validToken();
      if (response.data === true) return;
    } catch (err) {
      // Generate a fresh public token cookie below.
    }

    try {
      const response = await AuthFetchAPI.generatePublicToken(business.id);
      token = response?.data?.token || undefined;
    } catch (err) {
      return;
    }
  }


  // get status change of the info to  menu
  const getStatusContentMenu = async (budinessParthner, branchofficeParthner, machineParthner) => {

    let business_id = 0
    let branchoffice_id_general = 0
    let machine_id = 0

    if (budinessParthner === undefined) {
      business_id = business.id
      branchoffice_id_general = branchoffice.id
      machine_id = machine.id
    } else {
      business_id = budinessParthner
      branchoffice_id_general = branchofficeParthner
      machine_id = machineParthner
    }



    // generalData es un cache con el menu de CADA sucursal ya visitada en este telefono. Antes, si ya existia, siempre
    // se actualizaba "la entrada de esta sucursal" (paso 2): si el cache solo traia OTRAS sucursales (el cliente ya
    // habia entrado a otra antes y ahora entra por el QR de una mesa de una sucursal distinta) esa entrada no existia,
    // nunca se agregaba, dataconsolidation devolvia {} y el menu reventaba -> /branch -> "la sesion de mesa mantiene
    // la sucursal actual" -> /menu -> ... en bucle. Ahora: sin cache -> crear (1); con cache y con esta sucursal ->
    // actualizar (2); con cache pero sin esta sucursal -> agregarla (3).
    let cachedGeneralData = null
    try {
      cachedGeneralData = JSON.parse(localStorage.getItem('generalData'))
    } catch (err) {
      cachedGeneralData = null
    }
    if (!Array.isArray(cachedGeneralData) || cachedGeneralData.length === 0) {
      await getDataGeneralSmartpay(business_id, branchoffice_id_general, machine_id, 1)
    } else if (cachedGeneralData.some((entry) => entry && entry.branchoffice_id == branchoffice_id_general)) {
      await getDataGeneralSmartpay(business_id, branchoffice_id_general, machine_id, 2)
    } else {
      await getDataGeneralSmartpay(business_id, branchoffice_id_general, machine_id, 3)
    }
  }

  //Function get the groups by machine
  const getDataGeneralSmartpay = async (business_id, branchoffice_id, machine_id, step) => {

    try {

      const response = await AuthFetchAPI.getMenuGenerate(token, machine_id, branchoffice_id, business_id)
      let data = []
      
      switch (step) {
        case 1:
          data = [{ "branchoffice_id": branchoffice_id, "data": response.data.data }]
          break;
        case 2:
          let generalData1 = JSON.parse(localStorage.getItem('generalData'))


          generalData1.forEach((dataNow) => {
            if (dataNow.branchoffice_id == branchoffice_id) {
              dataNow.data = response.data.data
            }
          })

          data = generalData1

          break;
        case 3:
          let generalData2 = JSON.parse(localStorage.getItem('generalData'))
          generalData2.push({ "branchoffice_id": branchoffice_id, "data": response.data.data })
          data = generalData2

          break;

      }

      localStorage.setItem('generalData', JSON.stringify(data))
      dataconsolidation(data)
    } catch (err) {
      data = 'error'

    }
  }

  //consolidates data into corresponding statements
  const dataconsolidation = (generalData) => {
    let position = {}

    generalData.forEach((dataNow) => {
      if (dataNow.branchoffice_id == branchoffice.id) {
        position = dataNow.data
      }
    })
    data = position
  }


  // We check wich delivery fee rule is active and we get the data
  const getDeliveryFeeRule = async () => {
    try {
      const response = await DeliveryFeeRulesFetchAPI.getDeliveryFeeRules(business.id, undefined, "ecommerce", token);
      //We check if we have any delivery fee rule
      if (response.data.data.length > 0) {
        //We map the rules and get the ones that are active
        let activeRules = response.data.data.filter(({ is_active }) => is_active === 1);
       
        //We map the active rules and get the details of each rule
        for (let i = 0; i < activeRules.length; i++) {
          const responseDetails = await DeliveryFeeRulesFetchAPI.getDetailsDeliveryFeeRules(activeRules[i].id, token);
          //We check if the delivery fee rule is taxable
          if (responseDetails.data.data.taxable === 1) {
            activeRules[i].taxes = responseDetails.data.data.taxes
          } else {
            activeRules[i].taxes = []
          }
        }
        //We save the active rules in localStorage
        localStorage.setItem('deliveryFeeRule', JSON.stringify(activeRules))
      } else {
        localStorage.setItem('deliveryFeeRule', null)
      }
    } catch (err) {
      localStorage.setItem('deliveryFeeRule', null)
    }
  }

  //Function to get the pick&go rules
   const getPickAndGoRule = async () => {
    try {
      const response = await PickAndGoRulesFetchAPI.getPickAndGoRules(business.id, token);
      //We check if we have any pick and go rule
      if (response.data.rules.length > 0) {
        //We map the rules and get the ones that are active
        let activeRules = response.data.rules.filter(({ is_active }) => is_active === 1);
        //For each active rule we get the products assigned to it if is a rule type product
        for (let i = 0; i < activeRules.length; i++) {
          if (activeRules[i].type === 'product') {
            const responseProducts = await PickAndGoRulesFetchAPI.getPickAndGoRuleProducts(activeRules[i].id, token);
            activeRules[i].products = responseProducts.data.items
          }
        }
        //We save the active rules in localStorage
        localStorage.setItem('pickAndGoRule', JSON.stringify(activeRules))
      }
    } catch (err) {
      localStorage.setItem('pickAndGoRule', null)
    }
  }
  await ensurePublicToken();
  await getStatusContentMenu();
  await getDeliveryFeeRule();
  await getPickAndGoRule();

  //return data
  return data
}

export default initData
